
import { Node } from './storeClasses/node';
import { Service } from './storeClasses/service';
import { Topic } from './storeClasses/topic';
import { defineComponent, PropType } from 'vue';
import SearchableDropDown from '@/modules/globalModule/components/SearchableDropDown.vue';
import { PackageT } from '@/modules/nodesCanvasModule/components/storeClasses/packageT';
import ActiveMessagesPopup from './ActiveMessagesPopup.vue';

interface FilteredMessage {
  name: string;
  type: string;
  message?: Topic | Service | Node;
}
export default defineComponent({
  name: 'ActiveMessages',
  components: { SearchableDropDown, ActiveMessagesPopup },
  data(): {
    messageFilter: string;
    messagePage: number;
    packages: Array<PackageT | { name: string; id: string }>;
    packageToFilter: PackageT | null;
    popupVisible: boolean;
  } {
    return {
      messageFilter: '',
      messagePage: 0,
      packages: [{ name: 'all', id: '1' }],
      packageToFilter: null,
      popupVisible: false
    };
  },
  props: {
    onMouseUp: {
      type: Function as PropType<(message: Topic | Service | Node) => void>,
      required: false,
      default: () => {}
    },
    isHovering: {
      type: Boolean,
      required: false,
      default: true
    },
    externalPackages: {
      type: Array as PropType<Array<PackageT>>,
      required: false,
      default: []
    }
  },
  methods: {
    filterMessages(messageType: string): void {
      if (this.messageFilter === messageType) this.messageFilter = '';
      else this.messageFilter = messageType;
      this.messagePage = 0;
    },
    getFilteredMessages(): Array<FilteredMessage> {
      let renderMessages: Array<FilteredMessage> = [];
      if (this.packageToFilter === null) {
        if (this.messageFilter === 'topic' || this.messageFilter === '') {
          renderMessages = renderMessages.concat(
            this.externalPackages.reduce<FilteredMessage[]>(
              (accumulator, pkg) => {
                return accumulator.concat(
                  pkg.topics.map((topic) => {
                    return {
                      name: topic.name,
                      type: 'topic',
                      message: topic
                    };
                  })
                );
              },
              []
            )
          );
        }
        if (this.messageFilter === 'service' || this.messageFilter === '') {
          renderMessages = renderMessages.concat(
            this.externalPackages.reduce<FilteredMessage[]>(
              (accumulator, pkg) => {
                return accumulator.concat(
                  pkg.services.map((service) => {
                    return {
                      name: service.name,
                      type: 'service',
                      message: service
                    };
                  })
                );
              },
              []
            )
          );
        }
        if (this.messageFilter === 'node' || this.messageFilter === '') {
          renderMessages = renderMessages.concat(
            this.externalPackages.reduce<FilteredMessage[]>(
              (accumulator, pkg) => {
                return accumulator.concat(
                  pkg.nodes.map((node) => {
                    return {
                      name: node.name,
                      type: 'node',
                      message: node
                    };
                  })
                );
              },
              []
            )
          );
        }
      } else {
        if (this.messageFilter === 'topic' || this.messageFilter === '') {
          renderMessages = renderMessages.concat(
            this.packageToFilter.topics.map((topic) => {
              return {
                name: topic.name,
                type: 'topic',
                message: topic
              };
            })
          );
        }
        if (this.messageFilter === 'service' || this.messageFilter === '') {
          renderMessages = renderMessages.concat(
            this.packageToFilter.services.map((service) => {
              return {
                name: service.name,
                type: 'service',
                message: service
              };
            })
          );
        }
        if (this.messageFilter === 'node' || this.messageFilter === '') {
          renderMessages = renderMessages.concat(
            this.packageToFilter.nodes.map((node) => {
              return {
                name: node.name,
                type: 'node',
                message: node
              };
            })
          );
        }
      }
      return renderMessages;
    },
    getRenderMessages() {
      return this.getFilteredMessages().slice(
        this.messagePage * 10,
        this.messagePage * 10 + 10
      );
    },
    switchMessagePage(increment: number): void {
      this.messagePage += increment;
      if (this.messagePage < 0) {
        this.messagePage = Math.floor(this.getFilteredMessages().length / 10);
      } else if (
        this.messagePage > Math.floor(this.getFilteredMessages().length / 10)
      ) {
        this.messagePage = 0;
      }
    },
    filterPackages(pkg: PackageT | { name: string; id: string }) {
      if (pkg.name === 'all' && pkg.id === '1') this.packageToFilter = null;
      else this.packageToFilter = pkg as PackageT;
    }
  }
});
